/** @flow */
import React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';
import GenderGraph from 'common/components/charts/GenderGraph';
import PrintingCard from 'common/modules/printing/styles/PrintingCard';
import AgeRangeGraph from 'common/components/charts/AgeRangeGraph';
import AgeRangeReaches from 'common/domain/AgeRangeReaches';
import GenderReach from 'common/domain/GenderReach';
import { GraphTitle, SimpleGraphWrapper } from 'common/modules/printing/styles/Graph';

const SCard = styled(PrintingCard)`
  margin-top: ${({ theme }) => theme.metrics.margin}px;
  flex-direction: column;
  padding: 5px;
  page-break-inside: avoid;
  justify-content: space-between;
`;

type Props = {
  gender: GenderReach;
  ageRange: AgeRangeReaches;
  t: any,
  style: any,
};

const DemoGeoPrintingCard = (props: Props) => {
  return (
    <SCard style={props.style}>
      <SimpleGraphWrapper>
        <GraphTitle>
          {props.t('ageRange')}
        </GraphTitle>
        <AgeRangeGraph
          animate={false}
          showLabels
          data={props.ageRange}
          commercialAgeGroupPlacement={'bottom'}
          hideInterpolated
        />
      </SimpleGraphWrapper>
      <SimpleGraphWrapper>
        <GraphTitle>
          {props.t('gender.name')}
        </GraphTitle>
        <GenderGraph
          animate={false}
          data={props.gender}
        />
      </SimpleGraphWrapper>
    </SCard>
  );
};

export default translate()(DemoGeoPrintingCard);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/printing/DemoGeoPrintingCard.js